export default __webpack_public_path__ + "static/SRUS SB121 - Product Specifications & Technical Data-6dc6635ab422d97b1a46bd0396da5a90.pdf";